import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {phoneFactLabelSx, phoneFactsSx, phoneFactValueSx} from '../mobileDesign.sx';
import {PhoneCardFactsProps} from './PhoneCardFacts.types';

/** How many a card may carry. Beyond this the card stops being scannable, which is its whole job. */
const MAX_FACTS = 4;

/**
 * The strip at the foot of a list card: two columns, the label above its value.
 *
 * Above rather than beside, because a value that starts wherever its label happens to end cannot be
 * read down a column — and reading down a column is the one thing a table did well that a list of
 * cards has to keep.
 */
export const PhoneCardFacts: FC<PhoneCardFactsProps> = ({facts}) => {
    const shown = facts.slice(0, MAX_FACTS);

    if (!shown.length) {
        return null;
    }

    return (
        <Box sx={phoneFactsSx}>
            {shown.map((fact, index) => (
                <Box
                    key={index}
                    sx={{display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0}}
                >
                    {/* `component="div"`, not the paragraph a Typography renders by default: a fact's
                        value is often a node the list already had - a price cell, a currency chip, a
                        link - and those render divs, which a <p> may not contain. */}
                    <Typography
                        component="div"
                        sx={phoneFactLabelSx}
                    >
                        {fact.label}
                    </Typography>
                    <Typography
                        component="div"
                        sx={phoneFactValueSx}
                    >
                        {fact.value}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};
